module.exports = __webpack_public_path__ + "static/media/Doctor.73e63a0e.png";